import React from 'react';

export default function PriceTagsPrint({ products, onClose }) {
  if (!products || products.length === 0) {
    return (
      <div className="p-4">
        <p>No products to print.</p>
        {onClose && <button type="button" onClick={onClose} className="mt-2 underline">Close</button>}
      </div>
    );
  }

  return (
    <div className="p-4 print:p-2">
      <div className="flex justify-end gap-2 mb-4 print:hidden">
        <button
          type="button"
          onClick={() => window.print()}
          className="bg-indigo-600 text-white px-4 py-2 rounded"
        >
          Print
        </button>
        {onClose && (
          <button type="button" onClick={onClose} className="border px-4 py-2 rounded">
            Close
          </button>
        )}
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 print:gap-2">
        {products.map((p) => (
          <div
            key={p._id}
            className="border border-gray-300 rounded p-3 text-center print:break-inside-avoid"
            style={{ minHeight: '100px' }}
          >
            <p className="font-semibold text-sm truncate" title={p.name}>{p.name}</p>
            <p className="text-lg font-bold text-indigo-600 mt-1">P{Number(p.price).toFixed(2)}</p>
            {p.barcode && <p className="text-xs mt-1 font-mono">{p.barcode}</p>}
          </div>
        ))}
      </div>
    </div>
  );
}
